<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import UtilsMixin from "@/mixins/utils";
import DatePicker from "vue2-datepicker";
import PrintDebtCustomerOverviewDebt from "@/components/ipos/print-debt-customer-overview-debt";
import PrintDebtCustomerOverview from "@/components/ipos/print-debt-customer-overview";
import PrintReportDebtCustomer from "@/components/ipos/print-debt-customer";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import { commonService } from "@/services/common";
import { reportService } from "@/services/authservice/report";
import Multiselect from "vue-multiselect";
import { accountService } from "@/services/authservice/account";
import { customerService } from "@/services/authservice/customer";
import {exportExcelV2} from "@/plugins/export-excel";
import PrintHistoryDebtCustomer from "@/components/ipos/print-history-debt-customer.vue";
import moment from "moment";

export default {
  page: {
    title: "Báo cáo công nợ khách hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin],
  components: {
    PrintHistoryDebtCustomer,
    Layout,
    PageHeader,
    TableLoading,
    TableEmpty,
    PrintDebtCustomerOverview,
    PrintDebtCustomerOverviewDebt,
    PrintReportDebtCustomer,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      listData: [],
      listCustomer: [],
      listSalesman: [],
      listItem: [],
      title: "Báo cáo công nợ khách hàng",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Báo cáo",
          active: true,
        },
        {
          text: "Công nợ khách hàng",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      fields: [
        { key: "customer_id", label: "Mã khách hàng" },
        { key: "customer_name", label: "Tên khách hàng", class: "td-mw-200" },
        { key: "opening_debt_amount", label: "Nợ đầu kỳ" },
        { key: "order_amount", label: "Tiền mua hàng" },
        { key: "return_amount", label: "Tiền trả hàng" },
        { key: "paid_amount", label: "Tiền đã thanh toán" },
        { key: "debt_amount", label: "Nợ cuối kỳ" },
      ],
      isBusy: false,
      me: {},
      searchData: {
        customer: "",
        salesman: "",
        date: ['',new Date()],
      },
      distributorInfo: {},
      dataPrint: {},
      listHistory: [],
      dataSummaryHistory: {},
      listDetailByCustomer: [],
      titleModal: "Danh sách đơn hàng",
      dataSummary: {},
      dataSummaryDetail: {},
      selectedCustomer: {},
      tab: 'order',
      listTabs: ['order','history'],
      titleNoData: ''
    };
  },
  computed: {
    rows() {
      return this.listData.length;
    },
  },
  mounted() {
    this.totalRows = this.listData.length;
  },
  methods: {
    async getInitData() {
      const salesmanPromise = accountService.getList({ role_id: "SALESMAN" });
      const customerPromise = customerService.getListCustomer();
      const distributorPromise = commonService.getDistributorInfo({
        uid: this.me.distributor_uid,
      });
      // get list salesman
      const resSalesman = await salesmanPromise;
      this.listSalesman = resSalesman.data.data;
      // get list customer
      const resCustomer = await customerPromise;
      this.listCustomer = resCustomer.data.data;
      // get distributor
      const resDistributor = await distributorPromise;
      this.distributorInfo = resDistributor.data.data;
      // set filter default
      const startDay = moment().startOf('month').startOf('day').startOf('hour').startOf('minute').startOf('second').toDate();
      const lastDay = moment().endOf('hour').endOf('minute').endOf('second').toDate();
      this.searchData = {
        customer: "",
        salesman: "",
        date: [startDay,lastDay],
      };
    },

    async getListData(page) {
      if(!page) this.currentPage = 1;
      if(!this.searchData.date || !this.searchData.date[0]){
        this.searchData.date[0] = moment().startOf('month').startOf('day').startOf('hour').startOf('minute').startOf('second').toDate();
      }
      let param = {
        from_timestamp: this.searchData.date[0].getTime(),
        to_timestamp: this.searchData.date[1].getTime(),
        salesman_email: this.searchData.salesman
            ? this.searchData.salesman.email
            : "",
        customer_uid: this.searchData.customer
            ? this.searchData.customer.id
            : "",
      };
      const res = await reportService.getReportDebtCustomer(param);
      if (res.data.error) {
        this.titleNoData = 'Đã xảy ra lỗi. Vui lòng thử lại'
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data.error.message,
        });
      } else {
        this.listData = res.data.data;
        [
          'opening_debt_amount', 'order_amount', 'return_amount', 'paid_amount', 'debt_amount'
        ].forEach((e)=>{
          this.dataSummary[e] = this.listData.reduce((a,b)=>a+b[e],0)
        })
        if(this.listData.length === 0) this.titleNoData = 'Không có dữ liệu nào được tìm thấy'
      }
    },

    async checkParameter() {
      let firstDay = '';
      let lastDay = '';
      if (this.$route.query.to_timestamp) {
        if(this.$route.query.from_timestamp)
        firstDay = new Date(parseInt(this.$route.query.from_timestamp));
        lastDay = new Date(parseInt(this.$route.query.to_timestamp));
        this.searchData.date = [firstDay, lastDay];
      }
      if (this.$route.query.salesman) {
        this.searchData.salesman = this.listSalesman.find(
          (e) => e.email === this.$route.query.salesman
        );
      }
      if (this.$route.query.customer) {
        this.searchData.customer = this.listCustomer.find(
          (e) => e.id === this.$route.query.customer
        );
      }
      await this.getListData(true);
    },

    onPrintDebt() {
      let details = []
        this.listData.forEach(e => {
          if(e.debt_amount) details.push(e)
      });
      this.dataPrint = {
        date: this.searchData.date,
        customer: this.searchData.customer
          ? this.searchData.customer.customer_name
          : null,
        salesman: this.searchData.salesman
          ? this.searchData.salesman.name
          : null,
        summary: this.dataSummary,
        details: details
      };
      setTimeout(() => {
        this.$htmlToPaper(
          "printDebtOverviewDebt",
          this.localLandScapeOptions,
          async () => {}
        );
      }, 1000);
    },

    onPrint() {
      this.dataPrint = {
        date: this.searchData.date,
        customer: this.searchData.customer
          ? this.searchData.customer.customer_name
          : null,
        salesman: this.searchData.salesman
          ? this.searchData.salesman.name
          : null,
        summary: this.dataSummary,
        details: this.listData,
      };
      setTimeout(() => {
        this.$htmlToPaper(
          "printDebtOverview",
          this.localLandScapeOptions,
          async () => {}
        );
      }, 1000);
    },

    onExport() {
      let workbook = new Workbook();
      let header = this.fields.map((e) => {
        return { header: e.label, key: e.key };
      });
      const worksheet = workbook.addWorksheet("Báo cáo công nợ khách hàng");
      worksheet.properties.defaultColWidth = 30;
      worksheet.columns = header;

      this.listData.forEach((d) => {
        worksheet.addRow(d);
      });
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell) => {
          if (rowNumber === 1) {
            row.font = { bold: true };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            for (let i = 1; i <= 9; i++) {
              row.getCell(i).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "C7C7C7" },
              };
              row.getCell(i).border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
          cell.alignment = {
            wrapText: true,
          };
        });
      });

      // Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, `EXPORT_DEBT_CUSTOMER_${new Date().getTime()}.xlsx`);
      });
    },

    async onSearch() {
      let start = '';
      let end = '';
      if (
        this.searchData.date.length > 0 && this.searchData.date[1]
      ) {
        if(this.searchData.date[0]){
          start = this.searchData.date[0].setHours(0, 0, 0, 0);
        }
        end = this.searchData.date[1].setHours(23, 59, 59, 999);
      }
      const param = {
        salesman: this.searchData.salesman
          ? this.searchData.salesman.email
          : "",
        customer: this.searchData.customer ? this.searchData.customer.id : "",
        from_timestamp: start,
        to_timestamp: end,
        ts: new Date().getTime(),
      };
      let strParam = "";
      for (let key in param) {
        if (strParam !== "") {
          strParam += "&";
        }
        strParam += key + "=" + encodeURIComponent(param[key]);
      }
      if(this.checkDate()){
        this.$router.push(`?${strParam}`, () => {
        });
      }
    },

    onResetSearch() {
        this.$router.push("/report/debt-customer", () => {
      });
      this.getListData(true);
    },

    async onShowDetail(data) {
      if(this.checkDate()){
        this.selectedCustomer = data;
        this.titleModal = `Chi tiết công nợ của ${data.customer_name}`;
        this.tab = this.listTabs[0]
        await this.onChangeTabDetail();
        this.$bvModal.show("md-detail");
      }
    },

    async onChangeTabDetail(value) {
      this.tab = this.listTabs[value];
      let res = undefined;
      const {customer_uid} = this.selectedCustomer;
      let start = '';
      let end = '';
      if (
          this.searchData.date.length > 0 && this.searchData.date[1]
      ) {
        if(this.searchData.date[0])
          start = this.searchData.date[0].setHours(0, 0, 0, 0);
        end = this.searchData.date[1].setHours(23, 59, 59, 999);
      }
      if (this.tab === 'history') {
        res = await reportService.getReportDebtCustomerHistory({
          from_timestamp: start,
          to_timestamp: end,
          customer_uid,
          salesman_email: this.searchData.salesman
              ? this.searchData.salesman.email
              : "",
        })
        if(!res.data.data){
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: res.data.error.message,
          });
          this.dataSummaryHistory = {}
          this.listHistory = []
        }else{
          const {list_document, opening_debt_amount, close_debt_amount} = res.data.data;
          this.listHistory = [
            {
              document_type: 'opening_balance',
              document_type_text: 'Nợ đầu kỳ',
              debt_amount: opening_debt_amount,
              style: 'font-weight: bold'
            },
            {
              document_type: 'ending_balance',
              document_type_text: 'Nợ cuối kỳ',
              debt_amount: close_debt_amount,
              style: 'font-weight: bold'
            }
          ]
          let debt_amount = opening_debt_amount
          const listData = list_document && list_document.map(e=>{
            let document_type_text = e.document_type
            if(e.document_type === 'ORDER'){
              document_type_text = 'Đơn hàng'
              debt_amount = debt_amount + e.document_amount
            }else if(e.document_type === 'PAYMENT'){
              document_type_text = 'Phiếu thanh toán'
              debt_amount = debt_amount - e.document_amount
            }else if(e.document_type === 'RETURN'){
              document_type_text = 'Phiếu trả hàng'
              debt_amount = debt_amount - e.document_amount
            }
            return {
              ...e,
              document_type_text,
              debt_amount
            }
          }) || []
          this.listHistory.splice(1, 0,...listData)
          this.dataSummaryHistory = {
            openingDebtAmount: opening_debt_amount,
            closeDebtAmount: close_debt_amount
          }
        }
      }else if(this.tab === 'order'){
        res = await reportService.getReportDebtCustomerDetail({
          from_timestamp: start,
          to_timestamp: end,
          customer_uid: customer_uid,
          salesman_email: this.searchData.salesman
              ? this.searchData.salesman.email
              : "",
        });
        if(!res.data.data){
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: res.data.error.message,
          });
        }

        res.data.data
            ? (this.listDetailByCustomer = res.data.data)
            : (this.listDetailByCustomer = []);
        let totalFinalAmount = 0;
        let totalReturnAmount = 0;
        let totalPaidAmount = 0;
        let totalDebtAmount = 0;
        this.listDetailByCustomer.forEach((element) => {
          totalFinalAmount = totalFinalAmount + element.final_amount;
          totalReturnAmount = totalReturnAmount + element.return_amount;
          totalPaidAmount = totalPaidAmount + element.customer_paid_amount;
          totalDebtAmount = totalDebtAmount + element.customer_debt_amount;
        });
        this.dataSummaryDetail = {
          totalFinalAmount,
          totalReturnAmount,
          totalPaidAmount,
          totalDebtAmount,
        };
      }
    },

    customLabel({ sku, name }) {
      return `${sku} – ${name}`;
    },

    renderDate(type, activities) {
      switch (type) {
        case "create": {
          let find = activities.filter((e) => e.to_status === "CONFIRMED");
          return find.length > 0 ? this.formatDateUnix(find[0].timestamp) : "-";
        }
        case "export": {
          let find = activities.filter((e) => e.to_status === "EXPORTED");
          return find.length > 0 ? this.formatDateUnix(find[0].timestamp) : "-";
        }
        case "complete": {
          let find = activities.filter((e) => e.to_status === "COMPLETED");
          return find.length > 0 ? this.formatDateUnix(find[0].timestamp) : "-";
        }
      }
    },

    renderSalesman(id) {
      const find = this.listSalesman.find((e) => e.email === id);
      return find ? find.name : "-";
    },

    handleRenderLinkDocumentType(item){
      let link = undefined;
      if(item.document_type === 'ORDER'){
        link = this.$router.resolve({
          name: 'OrderDetail',
          params: {
            id: item.document_uid
          }
        })
      }else if(item.document_type === 'PAYMENT'){
        link = this.$router.resolve({
          name: 'PaidDetail',
          params: {
            id: item.document_uid
          }
        })
      }else if(item.document_type === 'RETURN'){
        link = this.$router.resolve({
          name: 'InventoryImportDetail',
          params: {
            id: item.document_uid
          }
        })
      }
      if(link){
        return `<a href="${link.href}" target="_blank">${item.document_id}</a>`
      }else{
        return item.document_id
      }
    },

    onPrintHistory(){
      this.dataPrint = {
        date: this.searchData.date,
        customer: this.selectedCustomer.customer_name,
        summary: {
          ...this.dataSummaryHistory,
        },
        details: this.listHistory.map(e=>{
          return {
            ...e,
            document_time: e.document_time && this.formatDate(e.document_time, 'hour') || '',
            document_amount: this.formatPrice(e.document_amount),
            debt_amount: this.formatPrice(e.debt_amount)
          }
        })
      };
      setTimeout(() => {
        this.$htmlToPaper(
            "printHistoryDebtCustomer",
            this.localLandScapeOptions,
            async () => {}
        );
      }, 1000);
    },

    onExportHistory(){
      let header = [
        {
          header: 'Thời gian',
          key: 'document_time'
        },
        {
          header: 'Mã chứng từ',
          key: 'document_id'
        },
        {
          header: 'Diễn giải',
          key: 'document_type_text'
        },
        {
          header: 'Giá trị',
          key: 'document_amount'
        },
        {
          header: 'Công nợ',
          key: 'debt_amount'
        }
      ]
      let data = this.listHistory.map(e=>{
        return {
          ...e,
          style: e.style ? {font: {bold: true}} : '',
          document_time: e.document_time && this.formatDate(e.document_time, 'hour') || '',
        }
      })
      exportExcelV2(header, data, {
        nameFile: 'REPORT_DEBT_CUSTOMER',
        nameTable:  `Phiếu báo nợ của ${this.selectedCustomer.customer_name}`
      })
    },

    onPrintDetail() {
      this.dataPrint = {
        date: this.searchData.date,
        customer: this.selectedCustomer.customer_name,
        details: this.listDetailByCustomer.map((e) => {
          return {
            salesman: this.renderSalesman(e.created_by),
            po_id: e.po_id,
            date_create: this.renderDate("create", e.activities),
            date_export: this.renderDate("export", e.activities),
            date_complete: this.renderDate("complete", e.activities),
            final_amount: this.formatPrice(e.final_amount),
            return_amount: this.formatPrice(e.return_amount),
            paid_amount: this.formatPrice(e.customer_paid_amount),
            customer_debt_amount: this.formatPrice(e.customer_debt_amount),
          };
        }),
        summary: this.dataSummaryDetail,
      };
      setTimeout(() => {
        this.$htmlToPaper(
          "printDebtCustomer",
          this.localLandScapeOptions,
          async () => {}
        );
      }, 1000);
    },

    onExportDetail() {
      let arrExport = this.listDetailByCustomer.map((e) => {
        return {
          salesman: this.renderSalesman(e.created_by),
          po_id: e.po_id,
          date_create: this.renderDate("create", e.activities),
          date_export: this.renderDate("export", e.activities),
          date_complete: this.renderDate("complete", e.activities),
          final_amount: this.formatPrice(e.final_amount),
          return_amount: this.formatPrice(e.return_amount),
          paid_amount: this.formatPrice(e.customer_paid_amount),
          customer_debt_amount: this.formatPrice(e.customer_debt_amount),
        };
      });

      let workbook = new Workbook();
      let header = [
        { header: "Salesman", key: "salesman" },
        { header: "Mã đơn", key: "po_id" },
        { header: "Ngày đặt", key: "date_create" },
        { header: "Ngày xuất kho", key: "date_export" },
        { header: "Ngày hoàn thành", key: "date_complete" },
        { header: "Tổng tiền", key: "final_amount" },
        { header: "Tiền đã trả lại", key: "return_amount" },
        { header: "Tiền đã thanh toán", key: "customer_paid_amount" },
        { header: "Tiền công nợ", key: "customer_debt_amount" },
      ];

      const worksheet = workbook.addWorksheet(
        "Công nợ khách hàng theo đơn hàng"
      );
      worksheet.properties.defaultColWidth = 30;
      worksheet.columns = header;

      arrExport.forEach((d) => {
        worksheet.addRow(d);
      });
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell) => {
          if (rowNumber === 1) {
            row.font = { bold: true };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            for (let i = 1; i <= 9; i++) {
              row.getCell(i).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "C7C7C7" },
              };
              row.getCell(i).border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
          cell.alignment = {
            wrapText: true,
          };
        });
      });

      // Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(
          blob,
          `EXPORT_REPORT_DEBT_CUSTOMER_${new Date().getTime()}.xlsx`
        );
      });
    },

    checkDate(){
      if(this.searchData.date.length>0 && this.searchData.date[0] && this.searchData.date[1]){
        if(this.searchData.date[0].getTime()>this.searchData.date[1].getTime()){
          this.$notify({
            group: "app",
            type: "error",
            title: "Trường lọc dữ liệu không phù hợp",
            text: 'Ngày bắt đầu cần nhỏ hơn ngày kết thúc',
          });
          return false;
        }else{
          return true;
        }
      }
      return  true;
    },

    onClearFilter(type){
      this.searchData[type] = null;
    }
  },
  watch: {
    $route: {
      handler: async function (from, to) {
        this.isBusy = true;
        this.me = JSON.parse(localStorage.getItem("user"));
        if (from.fullPath === "/report/debt-customer") {
          // mặc định khi vào màn hình, kiểm tra nếu là route gốc thì gọi init data + data default
          await this.getInitData();
          this.titleNoData = 'Vui lòng bấm lọc để lấy dữ liệu'
          // await this.getListData();
        } else {
          // nếu có param thì filter mặc định search data theo param
          if (!to) {
            // Khi F5 lại check nếu có param thì phải init data
            await this.getInitData();
          }
          await this.checkParameter();
        }
        this.isBusy = false;
      },
      deep: true,
      immediate: true,
    },
    searchData:{
      handler(){
        this.checkDate();
      },
      deep: true,
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-12">
                <!--Search form-->
                <form>
                  <div class="row">
                    <div class="col-12" style="display: contents">
                      <div class="form-group mt-0 mb-2 mr-2 min-w-250">
                        <date-picker
                          v-model="searchData.date[0]"
                          first-day-of-week="1"
                          :lang="langVi"
                          type="date"
                          format="DD/MM/YYYY"
                          placeholder="Từ ngày"
                          :clearable="false"
                        ></date-picker>
                      </div>
                      <div class="form-group mt-0 mb-2 mr-2 min-w-250">
                        <date-picker
                            v-model="searchData.date[1]"
                            first-day-of-week="1"
                            :lang="langVi"
                            type="date"
                            format="DD/MM/YYYY"
                            placeholder="Đến ngày"
                            :clearable="false"
                        ></date-picker>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                        <multiselect
                          v-model="searchData.salesman"
                          :options="listSalesman"
                          track-by="id"
                          label="name"
                          placeholder="Chọn Salesman"
                          noOptions="Danh sách trống"
                          :allowEmpty="true"
                          :show-labels="false"
                        >
                          <template slot="clear">
                            <div class="multiselect__select_clear" v-show="searchData.salesman" @mousedown.prevent.stop="()=>onClearFilter('salesman')"><i class="bx bx-x"></i></div>
                          </template>
                        </multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                        <multiselect
                          v-model="searchData.customer"
                          :options="listCustomer"
                          track-by="id"
                          label="customer_name"
                          placeholder="Chọn khách hàng"
                          noOptions="Danh sách trống"
                          :allowEmpty="true"
                          :show-labels="false"
                        >
                          <template slot="option" slot-scope="props">
                            <div>
                              <span class="option__title font-weight-bold">{{
                                props.option.customer_name
                              }}</span>
                              <br />
                              <span v-if="props.option.customer_phone"
                                >- SĐT: {{ props.option.customer_phone }}<br
                              /></span>

                              <span v-if="props.option.customer_address"
                                >- Địa chỉ:
                                {{ props.option.customer_address }}</span
                              >
                            </div>
                          </template>
                          <template slot="clear">
                            <div class="multiselect__select_clear" v-show="searchData.customer" @mousedown.prevent.stop="()=>onClearFilter('customer')"><i class="bx bx-x"></i></div>
                          </template>
                        </multiselect>
                      </div>
                      <div class="mt-0">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="onSearch"
                        >
                          Lọc
                        </button>
                        <button
                          type="button"
                          class="ml-2 btn btn-secondary"
                          @click="onResetSearch"
                        >
                          <i class="bx bx-revision"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
              <!-- Action -->
              <div class="col-sm-12 col-md-8">
                <div class="row mb-2">
                  <div class="col-lg-12">
                    <div class="d-flex justify-content-end">
                      <button
                        @click="onPrintDebt"
                        type="button"
                        class="btn btn-light mr-2"
                      >
                        <i
                          class="bx bx-printer font-size-16 align-middle mr-2"
                        ></i>
                        In công nợ cuối kỳ
                      </button>
                      <button
                        @click="onPrint"
                        type="button"
                        class="btn btn-light mr-2"
                      >
                        <i
                          class="bx bx-printer font-size-16 align-middle mr-2"
                        ></i>
                        In công nợ khách hàng
                      </button>
                      <button
                        @click="onExport"
                        type="button"
                        class="btn btn-light"
                      >
                        <i
                          class="bx bx-download font-size-16 align-middle mr-2"
                        ></i>
                        Export
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End add new -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                :items="listData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                table-class="scroll-table"
              >
                <template v-slot:table-busy>
                  <TableLoading />
                </template>
                <template v-slot:empty>
                  <TableEmpty :title="titleNoData"/>
                </template>
                <template #thead-top="data">
                  <b-tr>
                    <b-th colspan="2">Tổng</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.opening_debt_amount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.order_amount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.return_amount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.paid_amount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.debt_amount)
                    }}</b-th>
                  </b-tr>
                </template>
                <template v-slot:cell(index)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template v-slot:cell(customer_name)="row">
                  <a
                    href="javascript:void(0);"
                    @click="onShowDetail(row.item)"
                    >{{ row.item.customer_name }}</a
                  >
                </template>
                <template v-slot:cell(opening_debt_amount)="row">
                  {{ formatPrice(row.item.opening_debt_amount) }}
                </template>
                <template v-slot:cell(order_amount)="row">
                  {{ formatPrice(row.item.order_amount) }}
                </template>
                <template v-slot:cell(return_amount)="row">
                  {{ formatPrice(row.item.return_amount) }}
                </template>
                <template v-slot:cell(paid_amount)="row">
                  {{ formatPrice(row.item.paid_amount) }}
                </template>
                <template v-slot:cell(debt_amount)="row">
                  {{ formatPrice(row.item.debt_amount) }}
                </template>
              </b-table>
            </div>
            <div class="row" v-if="listData.length > 0 && !isBusy">
              <div class="col">
                <div class="mt-3 float-right">
                  <b-pagination
                    class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!--  Print container  -->
    <div
      id="printDebtOverview"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy"
    >
      <PrintDebtCustomerOverview
        :data="dataPrint"
        :distributor="distributorInfo"
        :me="me"
      />
    </div>
    <!--  Print container công nợ khách hàng -->
    <div
      id="printDebtOverviewDebt"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy"
    >
      <PrintDebtCustomerOverviewDebt
        :data="dataPrint"
        :distributor="distributorInfo"
        :me="me"
      />
    </div>

    <div
      id="printDebtCustomer"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy"
    >
      <PrintReportDebtCustomer
        :data="dataPrint"
        :distributor="distributorInfo"
        :me="me"
      />
    </div>

    <div
        id="printHistoryDebtCustomer"
        class="bg-white p-3 text-dark d-none"
        v-if="!isBusy"
    >
      <print-history-debt-customer
          :data="dataPrint"
          :distributor="distributorInfo"
          :me="me"
      />
    </div>
    <!--  Detail SKU  -->
    <b-modal id="md-detail" :title="titleModal" size="lg" centered hide-footer>
      <div class="row">
        <div class="col-lg-12">
          <b-tabs align="center" @input="onChangeTabDetail">
            <b-tab title="Lịch sử đơn hàng">
              <div class="mb-3 mt-3 d-flex justify-content-end">
                <button
                    @click="onPrintDetail"
                    type="button"
                    class="btn btn-light mr-2"
                >
                  <i class="bx bx-printer font-size-16 align-middle mr-2"></i> In
                  danh sách
                </button>
                <button @click="onExportDetail" type="button" class="btn btn-light">
                  <i class="bx bx-download font-size-16 align-middle mr-2"></i>
                  Export danh sách
                </button>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered scroll-table">
                  <thead>
                  <tr>
                    <b-th class="text-left" colspan="5">Tổng</b-th>
                    <b-th class="font-weight-bold text-left">{{
                        formatPrice(dataSummaryDetail.totalFinalAmount)
                      }}</b-th>
                    <b-th class="font-weight-bold text-left">{{
                        formatPrice(dataSummaryDetail.totalReturnAmount)
                      }}</b-th>
                    <b-th class="font-weight-bold text-left">{{
                        formatPrice(dataSummaryDetail.totalPaidAmount)
                      }}</b-th>
                    <b-th class="font-weight-bold text-left">{{
                        formatPrice(dataSummaryDetail.totalDebtAmount)
                      }}</b-th>
                  </tr>
                  <tr>
                    <th scope="col" class="min-w-75">Salesman</th>
                    <th scope="col" class="min-w-75">Mã đơn</th>
                    <th scope="col" class="min-w-75">Ngày đặt</th>
                    <th scope="col" class="min-w-120">Ngày xuất kho</th>
                    <th scope="col" class="min-w-140">Ngày hoàn thành</th>
                    <th scope="col" class="min-w-75">Tồng tiền</th>
                    <th scope="col" class="min-w-120">Tiền đã trả lại</th>
                    <th scope="col" class="min-w-200">Tiền đã thanh toán</th>
                    <th scope="col" class="min-w-120">Tiền công nợ</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in listDetailByCustomer" :key="item.po_id">
                    <td>{{ renderSalesman(item.created_by) }}</td>
                    <td>
                      <router-link
                          target="_blank"
                          :to="{ name: 'OrderDetail', params: { id: item.id } }"
                      >
                        {{ item.po_id }}
                      </router-link>
                    </td>
                    <td>{{ renderDate("create", item.activities) }}</td>
                    <td>{{ renderDate("export", item.activities) }}</td>
                    <td>{{ renderDate("complete", item.activities) }}</td>
                    <td>{{ formatPrice(item.final_amount) }}</td>
                    <td>{{ formatPrice(item.return_amount) }}</td>
                    <td>{{ formatPrice(item.customer_paid_amount) }}</td>
                    <td>{{ formatPrice(item.customer_debt_amount) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Lịch sử công nợ">
              <div class="mb-3 mt-3 d-flex justify-content-end">
              <button
                  @click="onPrintHistory"
                  type="button"
                  class="btn btn-light mr-2"
              >
                <i class="bx bx-printer font-size-16 align-middle mr-2"></i> In
                phiếu báo nợ
              </button>
              <button @click="onExportHistory" type="button" class="btn btn-light">
                <i class="bx bx-download font-size-16 align-middle mr-2"></i>
                Export phiếu báo nợ
              </button>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered scroll-table">
                  <thead>
                  <tr>
                    <th scope="col" class="min-w-75">Thời gian</th>
                    <th scope="col" class="min-w-75">Mã chừng từ</th>
                    <th scope="col" class="min-w-75">Diễn giải</th>
                    <th scope="col" class="min-w-120">Giá trị</th>
                    <th scope="col" class="min-w-120">Công nợ</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in listHistory" :key="item.document_id" :style="item.style||''">
                    <td>{{item.document_time&&formatDate(item.document_time, 'hour') || ''}}</td>
                    <td>
                      <div v-html="handleRenderLinkDocumentType(item)"/>
                    </td>
                    <td>{{item.document_type_text}}</td>
                    <td>{{ formatPrice(item.document_amount) }}</td>
                    <td>{{ formatPrice(item.debt_amount) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
